export default "__VITE_ASSET__Cc8IoxO6__"